import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
const FIRST_DELAY = 8000;
const INTERVAL = 15000;
const VISIBLE_FOR = 6000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let interval: number | undefined;
    const hideTimers: number[] = [];
    const show = () => {
      setVisible(true);
      hideTimers.push(window.setTimeout(() => {
        setVisible(false);
        setIndex(current => (current + 1) % purchases.length);
      }, VISIBLE_FOR));
    };
    const firstTimer = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(firstTimer);
      hideTimers.forEach(timer => window.clearTimeout(timer));
      if (interval) window.clearInterval(interval);
    };
  }, [dismissed]);
  const purchase = purchases[index];
  return <div className="pointer-events-none fixed inset-x-4 bottom-4 z-40 flex justify-start sm:inset-x-auto sm:left-6 sm:bottom-6" aria-live="polite" data-id="element-169" data-mp="jui6nbkjgfyu">
      <AnimatePresence data-id="element-170" data-mp="ex8kq5wcymfr">
        {visible && !dismissed ? <motion.div key={`${purchase.name}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl border border-sandDark bg-ivory/95 px-3.5 py-3 shadow-lift backdrop-blur" data-id="element-171" data-mp="1cjfo5cgxe8qj">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest" data-id="element-172" data-mp="3j9vp4wgwbcif">
              <CheckIcon className="h-4 w-4 text-ivory" aria-hidden="true" data-id="element-173" data-mp="3kq9grnx7ihlw" />
            </span>

            <div className="min-w-0 flex-1" data-id="element-174" data-mp="3pqfb5buv2i7o">
              <p className="truncate text-[0.82rem] font-semibold leading-tight text-ink" data-id="element-175" data-mp="3ppdqcfo1mhcr">
                {purchase.name} · {purchase.location}
              </p>
              <p className="mt-0.5 truncate text-[0.68rem] leading-tight text-muted" data-id="element-176" data-mp="3fqwub4a8zcju">
                Just got Yoga Teacher System™ · {purchase.minutesAgo} min ago
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="shrink-0 rounded-full p-1 text-muted transition-colors duration-150 ease-out hover:bg-cream hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-gold" data-id="element-177" data-mp="36r9q6aq4vsn3">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-178" data-mp="2n1zauxuav9pi" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}